import { getters } from "@/constants/state";

export default {
  [getters.TEMPLATE_SCHEDULES_EVENTS_GETTER]: (state) =>
    state.templateSchedules,
};
